'use client';

import { useSitePhotoArchiveEditor } from "@/app/features/sites/photo-archive/contexts/SitePhotoArchiveEditorContext";
import useIsDesktop from "@/hooks/useDesktop";
import { PhotoArchiveDetailFrame } from "@/app/features/sites/photo-archive/ui/shared/PhotoArchiveFrames";
import { DetailSectionEditable } from "@/app/features/shared/detail-section";
import { SitePhotoArchiveEditable } from "@/app/features/sites/photo-archive/types/types";

export default function PhotoArchiveDetailsSectionsEditable() {
    const isDesktop = useIsDesktop();

    const {
        editable,
        updateEditable,
    } = useSitePhotoArchiveEditor();

    if (!editable) {
        return null;
    }

    const updateDetail = (index: number, detail: Partial<SitePhotoArchiveEditable['details'][number]>) => {
        updateEditable({
            details: editable.details?.map((currentDetail, iterationIndex) =>
                iterationIndex === index ? { ...currentDetail, ...detail } : currentDetail
            ) || []
        });
    }

    return (
        <>
            {editable.details?.map((detail, index) => (
                <PhotoArchiveDetailFrame key={index} showDivider={index > 0}>
                    <DetailSectionEditable
                        data={detail}
                        alignment={isDesktop ? index % 2 === 0 ? 'row' : 'row-reverse' : 'column'}
                        onTitleChange={(title) => updateDetail(index, { title })}
                        onSubtitleChange={(subtitle) => updateDetail(index, { subtitle })}
                        onDescriptionChange={(description) => updateDetail(index, { description })}
                        onImageChange={(image) => {
                            if (image) updateDetail(index, { image });
                        }}
                    />
                </PhotoArchiveDetailFrame>
            ))}
        </>
    )
}
